// extracted by mini-css-extract-plugin
export var bodyRow = "_d5-d";
export var cardColumns = "_d5-e";
export var ellipsesOverflow = "_d5-2";
export var flatBottomCorners = "_d5-3";
export var flatTopCorners = "_d5-4";
export var headerActionsDropdown = "_d5-f";
export var headerBottomRow = "_d5-c";
export var headerTopRow = "_d5-b";
export var orderDetailsWrapper = "_d5-0";
export var orderInfoContainer = "_d5-1";
export var productDetails = "_d5-9";
export var productImage = "_d5-5";
export var responsiveTable = "_d5-8";
export var shipmentContainer = "_d5-a";
export var tableBottomLeft = "_d5-6";
export var tableBottomRight = "_d5-7";
export var trackingLink = "_d5-g";